<template>
    <vs-popup :title="titlePopUp" :active.sync="activatingPopUp" @close="activatingPopUp = false" class="p-5">
       <main class="mt-2">
           <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Nama Mitra</strong></h6>
              <span class="text-danger">*</span>
            </section>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="nama mitra"
              class="w-full sidebar-input"
              v-model="formData.namaMitra"
              placeholder="Isi dengan nama mitra"
            />
            <span class="text-danger text-sm">{{
              errors.first("nama mitra")
            }}</span>
          </div>
        </main>     
    </vs-popup>    
</template>
<script>
export default {
    props : {
        activate : {type: Boolean, default: false},
        passData : {type: Object, default: null}
    },
    data () {
        return {
            formData : {
                namaMitra : ""
            }
        }
    },
    computed : {
        titlePopUp () {
            return this.passData != null ? 'Edit Level' : 'Tambah Level'
        },
        activatingPopUp : {
            get () { return this.activate },
            set (val) {
                this.$emit('callback', val)
            }
        }
    }
}
</script>
